import { render, staticRenderFns } from "./LogisticPlaceholder.vue?vue&type=template&id=119eaae9&"
import script from "./LogisticPlaceholder.vue?vue&type=script&lang=js&"
export * from "./LogisticPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports